import { type Websocket } from 'entities/WebSocket/store'

interface IEventInboxConversationProps {
  id: number | string
}

export class ChannelInboxConversation {
  privateChannel?: string
  presenceChannel?: string

  constructor(props: IEventInboxConversationProps, private _websocket: Websocket) {
    if (props.id !== 0) {
      this.presenceChannel = `presence-inbox.${props.id}.conversation`
      this.privateChannel = `private-inbox.${props.id}.conversation`
      this.subscribe()
    }
  }

  subscribe() {
    this._websocket.subscribe(this.presenceChannel)
    this._websocket.subscribe(this.privateChannel)
  }
}
